import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSome as t } from "../../core/maybe.js";
import e from "./reservedWordsGLSL3.js";
import { o as a, l as r, b as n } from "../../chunks/builtins.js";
var o = 999,
    i = 9999,
    s = 0,
    c = 1,
    d = 2,
    f = 3,
    p = 4,
    u = 5,
    l = 6,
    h = 7,
    y = 8,
    w = 9,
    g = 10,
    m = 11,
    b = ["block-comment", "line-comment", "preprocessor", "operator", "integer", "float", "ident", "builtin", "keyword", "whitespace", "eof", "integer"];

function k() {
  var t,
      e,
      k,
      _ = 0,
      v = 0,
      j = o,
      x = [],
      E = [],
      O = 1,
      C = 0,
      L = 0,
      D = !1,
      G = !1,
      T = "";
  return function (t) {
    return E = [], null !== t ? F(t.replace ? t.replace(/\r\n/g, "\n") : t) : P();
  };

  function X(t) {
    t.length && E.push({
      type: b[j],
      data: t,
      position: L,
      line: O,
      column: C
    });
  }

  function F(e) {
    var a;

    for (_ = 0, k = (T += e).length; t = T[_], _ < k;) {
      switch (a = _, j) {
        case s:
          _ = $();
          break;

        case c:
          _ = V();
          break;

        case d:
          _ = A();
          break;

        case f:
          _ = z();
          break;

        case p:
          _ = Z();
          break;

        case m:
          _ = W();
          break;

        case u:
          _ = q();
          break;

        case i:
          _ = B();
          break;

        case w:
          _ = S();
          break;

        case o:
          _ = M();
      }

      if (a !== _) if ("\n" === T[a]) C = 0, ++O;else ++C;
    }

    return v += _, T = T.slice(_), E;
  }

  function P(t) {
    return x.length && X(x.join("")), j = g, X("(eof)"), E;
  }

  function M() {
    return x = x.length ? [] : x, "/" === e && "*" === t ? (L = v + _ - 1, j = s, e = t, _ + 1) : "/" === e && "/" === t ? (L = v + _ - 1, j = c, e = t, _ + 1) : "#" === t ? (j = d, L = v + _, _) : /\s/.test(t) ? (j = w, L = v + _, _) : (D = /\d/.test(t), G = /[^\w_]/.test(t), L = v + _, j = D ? p : G ? f : i, _);
  }

  function S() {
    return /[^\s]/g.test(t) ? (X(x.join("")), j = o, _) : (x.push(t), e = t, _ + 1);
  }

  function A() {
    return "\r" !== t && "\n" !== t || "\\" === e ? (x.push(t), e = t, _ + 1) : (X(x.join("")), j = o, _);
  }

  function V() {
    return A();
  }

  function $() {
    return "/" === t && "*" === e ? (x.push(t), X(x.join("")), j = o, _ + 1) : (x.push(t), e = t, _ + 1);
  }

  function z() {
    if ("." === e && /\d/.test(t)) return j = u, _;
    if ("/" === e && "*" === t) return j = s, _;
    if ("/" === e && "/" === t) return j = c, _;

    if ("." === t && x.length) {
      for (; I(x);) {
        ;
      }

      return j = u, _;
    }

    if (";" === t || ")" === t || "(" === t) {
      if (x.length) for (; I(x);) {
        ;
      }
      return X(t), j = o, _ + 1;
    }

    var a = 2 === x.length && "=" !== t;

    if (/[\w_\d\s]/.test(t) || a) {
      for (; I(x);) {
        ;
      }

      return j = o, _;
    }

    return x.push(t), e = t, _ + 1;
  }

  function I(t) {
    for (var e, r, n = 0;;) {
      if (e = a.indexOf(t.slice(0, t.length + n).join("")), r = a[e], -1 === e) {
        if (n-- + t.length > 0) continue;
        r = t.slice(0, 1).join("");
      }

      return X(r), L += r.length, (x = x.slice(r.length)).length;
    }
  }

  function W() {
    return /[^a-fA-F0-9]/.test(t) ? (X(x.join("")), j = o, _) : (x.push(t), e = t, _ + 1);
  }

  function Z() {
    return "." === t || /[eE]/.test(t) ? (x.push(t), j = u, e = t, _ + 1) : "x" === t && 1 === x.length && "0" === x[0] ? (j = m, x.push(t), e = t, _ + 1) : /[^\d]/.test(t) ? (X(x.join("")), j = o, _) : (x.push(t), e = t, _ + 1);
  }

  function q() {
    return "f" === t && (x.push(t), e = t, _ += 1), /[eE]/.test(t) || "-" === t && /[eE]/.test(e) ? (x.push(t), e = t, _ + 1) : /[^\d]/.test(t) ? (X(x.join("")), j = o, _) : (x.push(t), e = t, _ + 1);
  }

  function B() {
    if (/[^\d\w_]/.test(t)) {
      var a = x.join("");
      return j = r.indexOf(a) > -1 ? y : n.indexOf(a) > -1 ? h : l, X(x.join("")), j = o, _;
    }

    return x.push(t), e = t, _ + 1;
  }
}

function _(t) {
  var e = k(),
      a = [];
  return a = (a = a.concat(e(t))).concat(e(null));
}

function v(t) {
  return _(t);
}

function j(t) {
  return t.map(function (t) {
    return "eof" !== t.type ? t.data : "";
  }).join("");
}

var x = ["GL_OES_standard_derivatives", "GL_EXT_frag_depth", "GL_EXT_draw_buffers", "GL_EXT_shader_texture_lod"];

function E(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "100";
  var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "300 es";
  var r = /^\s*\#version\s+([0-9]+(\s+[a-zA-Z]+)?)\s*/;

  var _iterator = _createForOfIteratorHelper(t),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _n = _step.value;

      if ("preprocessor" === _n.type) {
        var _t = r.exec(_n.data);

        if (_t) {
          var _r = _t[1].replace(/\s\s+/g, " ");

          if (_r === a) return _r;
          if (_r === e) return _n.data = "#version " + a, e;
          throw new Error("unknown glsl version: " + _r);
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return t.splice(0, 0, {
    type: "preprocessor",
    data: "#version " + a
  }, {
    type: "whitespace",
    data: "\n"
  }), null;
}

function O(t, e) {
  for (var _a = e - 1; _a >= 0; _a--) {
    var _e = t[_a];

    if ("whitespace" !== _e.type && "block-comment" !== _e.type) {
      if ("keyword" !== _e.type) break;
      if ("attribute" === _e.data || "in" === _e.data) return !0;
    }
  }

  return !1;
}

function C(t, e, a, r) {
  r = r || a;

  var _iterator2 = _createForOfIteratorHelper(t),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _n2 = _step2.value;

      if ("ident" === _n2.type && _n2.data === a) {
        r in e ? e[r]++ : e[r] = 0;
        return C(t, e, r + "_" + e[r], r);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return a;
}

function L(t, e) {
  var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "afterVersion";

  function r(t, e) {
    for (var _a2 = e; _a2 < t.length; _a2++) {
      var _e2 = t[_a2];
      if ("operator" === _e2.type && ";" === _e2.data) return _a2;
    }

    return null;
  }

  function n(t) {
    var e = -1,
        n = 0,
        o = -1;

    for (var _i = 0; _i < t.length; _i++) {
      var _s = t[_i];

      if ("preprocessor" === _s.type && (_s.data.match(/\#(if|ifdef|ifndef)\s+.+/) ? ++n : _s.data.match(/\#endif\s*.*/) && --n), "afterVersion" !== a && "afterPrecision" !== a || "preprocessor" === _s.type && /^#version/.test(_s.data) && (o = Math.max(o, _i)), "afterPrecision" === a && "keyword" === _s.type && "precision" === _s.data) {
        var _e3 = r(t, _i);

        if (null === _e3) throw new Error("precision statement not followed by any semicolons!");
        o = Math.max(o, _e3);
      }

      e < o && 0 === n && (e = _i);
    }

    return e + 1;
  }

  var o = {
    data: "\n",
    type: "whitespace"
  },
      i = function i(e) {
    return e < t.length && /[^\r\n]$/.test(t[e].data);
  };

  var s = n(t);
  i(s - 1) && t.splice(s++, 0, o);

  var _iterator3 = _createForOfIteratorHelper(e),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _c = _step3.value;
      t.splice(s++, 0, _c);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  i(s - 1) && i(s) && t.splice(s, 0, o);
}

function D(t, e, a) {
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "lowp";
  L(t, [{
    type: "keyword",
    data: "out"
  }, {
    type: "whitespace",
    data: " "
  }, {
    type: "keyword",
    data: r
  }, {
    type: "whitespace",
    data: " "
  }, {
    type: "keyword",
    data: a
  }, {
    type: "whitespace",
    data: " "
  }, {
    type: "ident",
    data: e
  }, {
    type: "operator",
    data: ";"
  }], "afterPrecision");
}

function G(t, e, a, r) {
  var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "lowp";
  L(t, [{
    type: "keyword",
    data: "layout"
  }, {
    type: "operator",
    data: "("
  }, {
    type: "keyword",
    data: "location"
  }, {
    type: "whitespace",
    data: " "
  }, {
    type: "operator",
    data: "="
  }, {
    type: "whitespace",
    data: " "
  }, {
    type: "integer",
    data: r.toString()
  }, {
    type: "operator",
    data: ")"
  }, {
    type: "whitespace",
    data: " "
  }, {
    type: "keyword",
    data: "out"
  }, {
    type: "whitespace",
    data: " "
  }, {
    type: "keyword",
    data: n
  }, {
    type: "whitespace",
    data: " "
  }, {
    type: "keyword",
    data: a
  }, {
    type: "whitespace",
    data: " "
  }, {
    type: "ident",
    data: e
  }, {
    type: "operator",
    data: ";"
  }], "afterPrecision");
}

function T(t, e) {
  var a,
      r,
      n = -1;

  for (var _o = e; _o < t.length; _o++) {
    var _e4 = t[_o];

    if ("operator" === _e4.type && ("[" === _e4.data && (a = _o), "]" === _e4.data)) {
      r = _o;
      break;
    }

    "integer" === _e4.type && (n = parseInt(_e4.data, 10));
  }

  return a && r && t.splice(a, r - a + 1), n;
}

function X(a, r) {
  var n = M(a);
  if (t(n)) return n;
  var o = v(a);
  if ("300 es" === E(o, "100", "300 es")) throw new Error("shader is already glsl 300 es");
  var i = null,
      s = null;
  var c = {},
      d = {};

  for (var _t2 = 0; _t2 < o.length; ++_t2) {
    var _a3 = o[_t2];

    switch (_a3.type) {
      case "keyword":
        35633 === r && "attribute" === _a3.data ? _a3.data = "in" : "varying" === _a3.data && (_a3.data = 35633 === r ? "out" : "in");
        break;

      case "builtin":
        if (/^texture(2D|Cube)(Proj)?(Lod|Grad)?(EXT)?$/.test(_a3.data.trim()) && (_a3.data = _a3.data.replace(/(2D|Cube|EXT)/g, "")), 35632 === r && "gl_FragColor" === _a3.data && (i || (i = C(o, c, "fragColor"), D(o, i, "vec4")), _a3.data = i), 35632 === r && "gl_FragData" === _a3.data) {
          var _e5 = T(o, _t2 + 1),
              _r2 = C(o, c, "fragData");

          G(o, _r2, "vec4", _e5, "mediump"), _a3.data = _r2;
        } else 35632 === r && "gl_FragDepthEXT" === _a3.data && (s || (s = C(o, c, "gl_FragDepth")), _a3.data = s);

        break;

      case "ident":
        if (e.indexOf(_a3.data) >= 0) {
          if (35633 === r && O(o, _t2)) throw new Error("attribute in vertex shader uses a name that is a reserved word in glsl 300 es");
          _a3.data in d || (d[_a3.data] = C(o, c, _a3.data)), _a3.data = d[_a3.data];
        }

    }
  }

  for (var _t3 = o.length - 1; _t3 >= 0; --_t3) {
    var _e6 = o[_t3];

    if ("preprocessor" === _e6.type) {
      var _a4 = _e6.data.match(/\#extension\s+(.*)\:/);

      if (_a4 && _a4[1] && x.indexOf(_a4[1].trim()) >= 0) {
        var _e7 = o[_t3 + 1];
        o.splice(_t3, _e7 && "whitespace" === _e7.type ? 2 : 1);
      }

      var _r3 = _e6.data.match(/\#ifdef\s+(.*)/);

      _r3 && _r3[1] && x.indexOf(_r3[1].trim()) >= 0 && (_e6.data = "#if 1");

      var _n3 = _e6.data.match(/\#ifndef\s+(.*)/);

      _n3 && _n3[1] && x.indexOf(_n3[1].trim()) >= 0 && (_e6.data = "#if 0");
    }
  }

  return S(a, j(o));
}

var F = {
  enableCache: !1
},
    P = new Map();

function M(t) {
  return F.enableCache ? P.get(t) : null;
}

function S(t, e) {
  return F.enableCache && P.set(t, e), e;
}

export { F as test, X as transpileShader };